var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.07V3.104a1.103 1.103 0 112.207 0v2.422a7.74 7.74 0 016.072-2.97c4.255 0 7.721 3.466 7.721 7.722S14.534 18 10.279 18a7.652 7.652 0 01-4.628-1.547 1.105 1.105 0 01-.22-1.546 1.106 1.106 0 011.546-.22 5.463 5.463 0 003.306 1.102 5.518 5.518 0 005.51-5.511 5.517 5.517 0 00-5.51-5.511 5.53 5.53 0 00-4.4 2.2H8.07a1.103 1.103 0 110 2.207H3.103C2.493 9.174 2 8.68 2 8.07zM10.656 7a.665.665 0 01.656.657v2.597l1.75 1.75c.274.273.274.684 0 .93a.6.6 0 01-.902 0l-1.969-1.97c-.136-.108-.191-.272-.191-.464V7.657c0-.356.273-.657.656-.657z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default ForwardRef;